import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './ContentContainer.module.scss';

const ContentContainer = ({
  children,
  fullBleed = false,
  wide = false,
  noPad,
  gapFix = false,
  className = '',
  ...rest
}) => {
  return (
    <div
      className={[
        wide ? styles.containerWide : '',
        noPad ? styles.noPad : '',
        fullBleed ? styles.containerFull : styles.container,
        gapFix ? styles.gapFix : '',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
};

ContentContainer.propTypes = {
  children: PropTypes.any,
  fullBleed: PropTypes.bool,
  wide: PropTypes.bool,
  className: PropTypes.string,
};

export default ContentContainer;
